import { Modal } from "../../components/Modal";
import { Button } from "../../components/ui/button";

interface DeleteSchedulerDialogProps {
  label: string;
  onCancel: () => void;
  onConfirm: () => void;
}

export function DeleteSchedulerDialog({ label, onCancel, onConfirm }: Readonly<DeleteSchedulerDialogProps>) {
  return (
    <Modal
      open
      onClose={onCancel}
      title={`Delete ${label} Schedule Configuration`}
      footer={
        <>
          {/* Variants carry the shape; the classes only restate the footer
              palette the other scheduler modals already use. */}
          <Button
            variant="outline"
            onClick={onCancel}
            className="rounded-lg border-[#e2e8f0] text-[#475569] hover:bg-[#f1f5f9] dark:border-white/[0.07] dark:bg-transparent dark:text-white/60 dark:hover:bg-white/[0.04]"
          >
            Cancel
          </Button>
          <Button variant="revoke" onClick={onConfirm} className="rounded-lg font-bold">
            Delete
          </Button>
        </>
      }
    >
      <p className="py-2 text-sm text-foreground">
        Are you sure you would like to delete the {label} Schedule Configuration?
      </p>
    </Modal>
  );
}
